import { HORIZONS_STYLE_ORDER } from './tagGenerator'

/** Minimum d'exercices publiés requis par style débloqué pour afficher l'UI Nouveaux Horizons (élèves). */
export const HORIZONS_MIN_PUBLISHED_PER_UNLOCKED_STYLE = 4

/**
 * Seuil effectif : entier ≥ 1 depuis VITE_HORIZONS_MIN_PER_STYLE, sinon constante par défaut.
 */
export function getHorizonsMinPublishedPerUnlockedStyle() {
  const raw = import.meta.env.VITE_HORIZONS_MIN_PER_STYLE
  if (raw != null && String(raw).trim() !== '') {
    const n = parseInt(String(raw).trim(), 10)
    if (!Number.isNaN(n) && n >= 1) return n
  }
  return HORIZONS_MIN_PUBLISHED_PER_UNLOCKED_STYLE
}

/**
 * Compte les exercices publiés Horizons par `metadata.musicCategory` (styles connus uniquement).
 * @param {Array<{ metadata?: { musicCategory?: string } }>} exercises
 * @returns {Record<string, number>}
 */
export function countHorizonsExercisesByStyle(exercises) {
  /** @type {Record<string, number>} */
  const counts = {}
  for (const id of HORIZONS_STYLE_ORDER) counts[id] = 0
  for (const ex of exercises || []) {
    const cat = ex.metadata?.musicCategory
    if (cat != null && Object.prototype.hasOwnProperty.call(counts, cat)) {
      counts[cat]++
    }
  }
  return counts
}

/**
 * @param {string[]} styleIds - styles débloqués côté progression
 * @param {Record<string, number>} countsByStyle
 * @param {number} min
 */
export function countsMeetMinimumForStyles(styleIds, countsByStyle, min) {
  if (!styleIds?.length) return true
  return styleIds.every((id) => (countsByStyle[id] ?? 0) >= min)
}
